import { HttpClient, HttpHeaders } from '@angular/common/http';

import { FilterAir } from '../model/filterAir';
import { HttpUtils } from '../utils/httpUtils';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class FilterService {

    constructor(private http: HttpClient) {
    }

    save(filter: FilterAir, timeStamp: string, executionId: number): Observable<any> {
        const url = environment.airUrl + `/execution/filter/create/${executionId}`;
        const headers = new HttpHeaders({
            timeStamp
        });
        return this.http.post(url, filter, { headers }).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    update(filter: FilterAir, timeStamp: string, executionId: number): Observable<any> {
        const url = environment.airUrl + `/execution/filter/${filter.id}/${executionId}`;
        const headers = new HttpHeaders({
            timeStamp
        });
        return this.http.put(url, filter, { headers }).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    delete(filter: FilterAir, timeStamp: string, executionId: number): Observable<any> {
        const url = environment.airUrl + `/execution/filter/${filter.id}/${executionId}`;
        const headers = new HttpHeaders({
            timeStamp
        });
        return this.http.delete(url, { headers }).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

}
